"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetPropertiesResponseDataDto = instanceOfGetPropertiesResponseDataDto;
exports.GetPropertiesResponseDataDtoFromJSON = GetPropertiesResponseDataDtoFromJSON;
exports.GetPropertiesResponseDataDtoFromJSONTyped = GetPropertiesResponseDataDtoFromJSONTyped;
exports.GetPropertiesResponseDataDtoToJSON = GetPropertiesResponseDataDtoToJSON;
exports.GetPropertiesResponseDataDtoToJSONTyped = GetPropertiesResponseDataDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var PropertyListItemDto_1 = require("./PropertyListItemDto");
/**
 * Check if a given object implements the GetPropertiesResponseDataDto interface.
 */
function instanceOfGetPropertiesResponseDataDto(value) {
    if (!('properties' in value) || value['properties'] === undefined)
        return false;
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    return true;
}
function GetPropertiesResponseDataDtoFromJSON(json) {
    return GetPropertiesResponseDataDtoFromJSONTyped(json, false);
}
function GetPropertiesResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'properties': (json['properties'].map(PropertyListItemDto_1.PropertyListItemDtoFromJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function GetPropertiesResponseDataDtoToJSON(json) {
    return GetPropertiesResponseDataDtoToJSONTyped(json, false);
}
function GetPropertiesResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'properties': (value['properties'].map(PropertyListItemDto_1.PropertyListItemDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
